import * as constants from "./actions";
import axios from "@/plugins/axios.js";


function getDefaultState() {
  return {
    reImportData: {
      status: null,
      data: [],
      error: null
    },
    exportLoadList: {
      status: null,
      data: [],
      error: null
    },
    completeReImport: {
      status: null,
      data: [],
      error: null
    },
    deleteReImport: {
      status: null,
      data: [],
      error: null
    },
    reImportVehicles: {
      status: null,
      data: [],
      error: null
    },
    reImportDataByVin: {
      status: null,
      data: [],
      error: null
    }
  }
}

const actions = {
  [constants.GET_REIMPORT_DATA]: async ({ commit }, payload) => {
    commit(constants.GET_REIMPORT_DATA);
    try {
      const response = await axios.get("exportLoad/getReImport", { params: payload });
      commit(constants.GET_REIMPORT_DATA_SUCCESS, response.data);
    } catch (error) {
      commit(constants.GET_REIMPORT_DATA_ERROR, error);
    }
  },
  [constants.GET_EXPORT_LOAD_LIST]: async ({ commit }, payload) => {
    commit(constants.GET_EXPORT_LOAD_LIST);
    try {
      const response = await axios.get("exportLoad/getExportLoadList", { params: payload });
      commit(constants.GET_EXPORT_LOAD_LIST_SUCCESS, response);
    } catch (error) {
      commit(constants.GET_EXPORT_LOAD_LIST_ERROR, error);
    }
  },
  [constants.POST_REIMPORT_DATA]: async ({ commit }, payload) => {
    commit(constants.POST_REIMPORT_DATA);
    try {
      const response = await axios.post("exportLoad/createReImport", payload);
      commit(constants.POST_REIMPORT_DATA_SUCCESS, response.data);
    } catch (error) {
      commit(constants.POST_REIMPORT_DATA_ERROR, error);
    }
  },
  [constants.PUT_COMPLETE_REIMPORT]: async ({ commit }, payload) => {
    commit(constants.PUT_COMPLETE_REIMPORT);
    try {
      const response = await axios.put("exportLoad/completeReImport", payload);
      commit(constants.PUT_COMPLETE_REIMPORT_SUCCESS, response.data);
    } catch (error) {
      commit(constants.PUT_COMPLETE_REIMPORT_ERROR, error);
    }
  },
  [constants.DELETE_REIMPORT]: async ({ commit }, payload) => {
    commit(constants.DELETE_REIMPORT);
    try {
      const response = await axios.delete("exportLoad/deleteReImport", { params: { ...payload } });
      commit(constants.DELETE_REIMPORT_SUCCESS, response.data);
    } catch (error) {
      commit(constants.DELETE_REIMPORT_ERROR, error);
    }
  },
  [constants.GET_RE_IMPORT_VEHICLES]: async ({ commit }, payload) => {
    commit(constants.GET_RE_IMPORT_VEHICLES);
    try {
      const response = await axios.get("exportLoad/getVehiclesReimportList", { params: payload });
      commit(constants.GET_RE_IMPORT_VEHICLES_SUCCESS, response);
    } catch (error) {
      commit(constants.GET_RE_IMPORT_VEHICLES_ERROR, error);
    }
  },
  [constants.GET_REIMPORT_DATA_BY_VIN]: async ({ commit }, payload) => {
    commit(constants.GET_REIMPORT_DATA_BY_VIN);
    try {
      const response = await axios.get("exportLoad/getReImportVehicles", { params: payload });
      commit(constants.GET_REIMPORT_DATA_BY_VIN_SUCCESS, response);
    } catch (error) {
      commit(constants.GET_REIMPORT_DATA_BY_VIN_ERROR, error);
    }
  }
}

const mutations = {
  [constants.GET_REIMPORT_DATA]: (state) => {
    state.reImportData.status = "fetching";
  },
  [constants.GET_REIMPORT_DATA_SUCCESS]: (state, data) => {
    state.reImportData.status = "success";
    state.reImportData.data = data;
  },
  [constants.GET_REIMPORT_DATA_ERROR]: (state, error) => {
    state.reImportData.status = "error";
    state.reImportData.error = error;
  },
  [constants.GET_EXPORT_LOAD_LIST]: (state) => {
    state.exportLoadList.status = "fetching ";
  },
  [constants.GET_EXPORT_LOAD_LIST_SUCCESS]: (state, data) => {
    state.exportLoadList.status = "success";
    state.exportLoadList.data = data;
  },
  [constants.GET_EXPORT_LOAD_LIST_ERROR]: (state, error) => {
    state.exportLoadList.status = "error";
    state.exportLoadList.error = error;
  },
  [constants.POST_REIMPORT_DATA]: (state) => {
    state.reImportData.status = "fetching ";
  },
  [constants.POST_REIMPORT_DATA_SUCCESS]: (state, data) => {
    state.reImportData.status = "success";
    state.reImportData.data = data;
  },
  [constants.POST_REIMPORT_DATA_ERROR]: (state, error) => {
    state.reImportData.status = "error";
    state.reImportData.error = error;
  },
  [constants.PUT_COMPLETE_REIMPORT]: (state) => {
    state.completeReImport.status = "fetching ";
  },
  [constants.PUT_COMPLETE_REIMPORT_SUCCESS]: (state, data) => {
    state.completeReImport.status = "success";
    state.completeReImport.data = data;
  },
  [constants.PUT_COMPLETE_REIMPORT_ERROR]: (state, error) => {
    state.completeReImport.status = "error";
    state.completeReImport.error = error;
  },
  [constants.DELETE_REIMPORT]: (state) => {
    state.deleteReImport.status = "fetching ";
  },
  [constants.DELETE_REIMPORT_SUCCESS]: (state, data) => {
    state.deleteReImport.status = "success";
    state.deleteReImport.data = data;
  },
  [constants.DELETE_REIMPORT_ERROR]: (state, error) => {
    state.deleteReImport.status = "error";
    state.deleteReImport.error = error;
  },
  [constants.GET_RE_IMPORT_VEHICLES]: (state) => {
    state.reImportVehicles.status = "fetching";
  },
  [constants.GET_RE_IMPORT_VEHICLES_SUCCESS]: (state, data) => {
    state.reImportVehicles.status = "success";
    state.reImportVehicles.data = data;
  },
  [constants.GET_RE_IMPORT_VEHICLES_ERROR]: (state, error) => {
    state.reImportVehicles.status = "error";
    state.reImportVehicles.error = error;
  },
  [constants.GET_REIMPORT_DATA_BY_VIN]: (state) => {
    state.reImportDataByVin.status = "fetching";
  },
  [constants.GET_REIMPORT_DATA_BY_VIN_SUCCESS]: (state, data) => {
    state.reImportDataByVin.status = "success";
    state.reImportDataByVin.data = data;
  },
  [constants.GET_REIMPORT_DATA_BY_VIN_ERROR]: (state, error) => {
    state.reImportDataByVin.status = "error";
    state.reImportDataByVin.error = error;
  }
}

export default {
  state: getDefaultState(),
  actions,
  mutations,
};